import {
  Box,
  Button,
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info"; // Import an icon
import { useQuery } from "@tanstack/react-query";
import React from "react";
import { singleFilter } from "./services/PANServices";
import { formatDate, formatTime } from "./Logs";

const LogsModal = ({ openModal, handleCloseModal, filters }) => {
  const { data: modalData } = useQuery({
    queryKey: ["single-logs", filters],
    queryFn: () =>
      singleFilter({
        filterType: filters.filterType,
        filter: filters.filter,
        type: filters.type,
      }),
  });

  const formatJSON = (json) => JSON.stringify(json, null, 2); // Nicely format JSON

  return (
    <Modal open={openModal} onClose={handleCloseModal}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 600,
          bgcolor: "background.paper",
          border: "2px solid #000",
          boxShadow: 24,
          p: 4,
        }}
      >
        <Typography variant="h6" mb={2}>
          Details for {filters?.filter}
        </Typography>
        <Typography>Calls Today: {modalData?.callsToday}</Typography>
        <Typography>Calls This Month: {modalData?.callsThisMonth}</Typography>
        <Typography>Calls This Year: {modalData?.callsThisYear}</Typography>
        <Typography variant="h6" mt={2}>
          Related Logs:
        </Typography>
        <TableContainer
          component={Paper}
          sx={{ maxHeight: 400, overflow: "auto" }}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {filters.filterType === "company" && (
                  <TableCell>User</TableCell>
                )}
                <TableCell>Date</TableCell>
                <TableCell>Time</TableCell>
                <TableCell>Action</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {modalData?.relatedLogs?.map((log, index) => (
                <TableRow key={index}>
                  {filters.filterType === "company" && (
                    <TableCell>{log?.email}</TableCell>
                  )}
                  <TableCell>{formatDate(log?.createdAt)}</TableCell>
                  <TableCell>{formatTime(log?.createdAt)}</TableCell>
                  <TableCell>{log?.UsedOn}</TableCell>
                  <TableCell>
                    <Tooltip
                      title={
                        <pre
                          style={{
                            margin: 0,
                            fontFamily: "monospace",
                            fontSize: "0.75rem",
                          }}
                        >
                          {formatJSON(log?.Misc)}
                        </pre>
                      }
                      arrow
                      placement="top"
                    >
                      <InfoIcon
                        sx={{
                          ml: 1,
                          color: "primary.main",
                          cursor: "pointer",
                        }}
                      />
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Button onClick={handleCloseModal} sx={{ mt: 2 }}>
          Close
        </Button>
      </Box>
    </Modal>
  );
};

export default LogsModal;
